import { bindActionCreators } from 'redux';

// shortcut for binding actions and wrapping them in "actions"
export const wrapActionCreators = actions => dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});
